module.exports = __webpack_public_path__ + "static/media/2.19ae946c.jpg";